export default "__VITE_ASSET__DZUs75EV__"